import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {

  dialog:any;

  constructor(
    private dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) data ) {
    this.dialog = data;
   }

  ngOnInit() {
  }

  cancel(){
    this.dialogRef.close();
  }
  confirm(){
    this.dialogRef.close(true);
  }
}
